const getAngleFromBearing = (bearing)=>{
    if (bearing===undefined) return null
    let _a = bearing
    if (_a<0) {return _a+360}
    return _a
}

export default getAngleFromBearing